import { z } from "zod"
import { SyncStatus } from "../workspace/flight-records"

export const ConnectedAccountSyncEventSchema = z.object({ integrationId: z.string() }).and(
    z.discriminatedUnion("status", [
        z.object({
            status: z.literal(SyncStatus.Syncing),
            totalCount: z.number(),
            successCount: z.number(),
            errorCount: z.number(),
        }),
        z.object({ status: z.literal(SyncStatus.Synced) }),
        z.object({ status: z.literal(SyncStatus.Error) }),
    ])
)

export type ConnectedAccountSyncEvent = z.infer<typeof ConnectedAccountSyncEventSchema>
